var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Disciplina",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nomeDisciplina,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nomeDisciplina", $$v);
      },
      expression: "form.filters.nomeDisciplina"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.form.lists.tiposDeDisciplina,
      "label": "Tipo de Disciplina",
      "item-text": "tipoDisciplina",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.tipoDisciplina,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "tipoDisciplina", $$v);
      },
      expression: "form.filters.tipoDisciplina"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarDisciplina();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Incluir",
      "icon": "mdi-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterDisciplina();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listDisciplinas,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nomeDisciplina`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nomeDisciplina) + " ")];
      }
    }, {
      key: `item.tipoDisciplina`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.tipoDisciplina) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar Disciplina",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarDisciplina(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Editar Disciplina",
            "icon": "mdi-pencil",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterDisciplina(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Excluir Disciplina",
            "icon": "mdi-delete",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.exclusaoDisciplina(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar Disciplina' : 'Ativar Disciplina'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.ativo ? 'var(--primary-button-color)' : 'silver'}`,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.alterarStatusDisciplina(item);
            }
          }
        })];
      }
    }, {
      key: `item.emUso`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Detalhar Uso',
            "icon": item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
            "color": item.emUso ? 'green' : 'red',
            "small": true,
            "disabled": !item.emUso
          },
          on: {
            "click": function ($event) {
              item.emUso ? _vm.openDialogDetalharUsoDisciplina(item) : null;
            }
          }
        })];
      }
    }], null, true)
  })], 1), _vm.dialogVisualizarDisciplina.visible ? _c('VisualizarDisciplinaDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarDisciplina.visible,
      "content": _vm.dialogVisualizarDisciplina.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarDisciplina.close();
      }
    }
  }) : _vm._e(), _c('CadastrarEditarDisciplinaDialog', {
    attrs: {
      "edit": _vm.dialogManterDisciplina.edit,
      "tipos": _vm.form.lists.tiposDeDisciplina,
      "visible": _vm.dialogManterDisciplina.visible,
      "content": _vm.dialogManterDisciplina.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterDisciplina.close();
      },
      "onSave": function ($event) {
        return _vm.buscarDisciplina();
      }
    }
  }), _c('DetalharUsoDisciplinaDialog', {
    attrs: {
      "visible": _vm.dialogDetalharUsoDisciplina.visible,
      "content": _vm.dialogDetalharUsoDisciplina.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogDetalharUsoDisciplina.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }